import React from 'react'
import { EMPTY_VALUE_DASH } from '../../constants'
import HelperTextLabel from '../HelperTextLabel'
import styles from './styles.module.less'

export interface ReadOnlyFieldDisplay {
  className?: string
  helpText?: string
  label: string
  required?: boolean
  value?: string
}

const ReadOnlyFieldDisplay = ({ className, label, helpText, required, value }: ReadOnlyFieldDisplay) => (
  <div
    className={`read-only-field-display ${styles.readOnlyFieldDisplay} ${required ? styles.required : ''} ${className}`}
  >
    <div className="helper-text-label-wrapper">
      <HelperTextLabel label={label} helperText={helpText} />
    </div>
    <label className="value-label">{value || EMPTY_VALUE_DASH}</label>
  </div>
)

export default ReadOnlyFieldDisplay
